import Vue from "vue";
import Router from "vue-router";
// const Goldlocker = () => import("../views/Goldlocker")
import Goldlocker from "../views/Goldlocker"
import SellGold from "../views/SellGold"
import BuyGold from "../views/BuyGold"
import Registration from "../views/Registration"
import Payment from "../views/Payment"
import Status from "../views/Status"
import DeliveryProcess from "../views/DeliveryProcess"
import PurchasePaymentForm from "../views/PurchasePaymentForm"
import AddNewAddress from "../components/AddNewAddress"
import MyOrders from "../views/MyOrders"
import GiftWrapper from "../views/GiftWrapper"
import GoldProductWrapper from "../views/GoldProductWrapper"
Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Goldlocker",
      component: Goldlocker
    },
    {
      path: "/sell-gold",
      name: "SellGold",
      component: SellGold
    },
    {
      path: "/buy-gold",
      name: "BuyGold",
      component: BuyGold
    },
    {
      path: "/registration",
      name: "Registration",
      component: Registration
    },
    {
      path: "/payment-confirmation",
      name: "Payment",
      component: Payment
    },
    {
      path: "/status",
      name: "Status",
      component: Status
    },
    {
      path: "/products",
      name: "DeliveryProcess",
      component: DeliveryProcess
    },
    {
      path: "/purchase-payment",
      name: "PurchasePaymentForm",
      component: PurchasePaymentForm
    },

    {
      path: "/product/:id",
      name: "GoldProductWrapper",
      component: GoldProductWrapper
    },

    {
      path: "/new-address",
      name: "AddNewAddress",
      component: AddNewAddress
    },

    {
      path: "/my-orders",
      name: "MyOrders",
      component: MyOrders
    },
    {
      path: "/gift-wrapper",
      name: "GiftWrapper",
      component: GiftWrapper
    }
  ]
});

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}